import { render, staticRenderFns } from "./header.vue?vue&type=template&id=084ca1cc&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=084ca1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-2064ba0760/5/root/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ca1cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../.yarn/__virtual__/vuetify-loader-virtual-36d94f05a9/5/root/.yarn/berry/cache/vuetify-loader-npm-1.7.2-d296a16f38-10c0.zip/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VBtn,VIcon,VSpacer})
